export const InputValidators = {
    // Importes, Dinero, Cantidades
    validateDecimalKeyDown: (e) => {
        const { key, target, ctrlKey, metaKey } = e;
        const allowedControlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

        if (ctrlKey || metaKey) return;

        if (allowedControlKeys.includes(key)) return;

        const value = target.value;
        const selectionStart = target.selectionStart;

        if (key === '.') {
            if (value.includes('.')) e.preventDefault();
            return;
        }

        if (/^[0-9]$/.test(key)) {
            const dotIndex = value.indexOf('.');
            if (dotIndex >= 0) {
                const decimals = value.slice(dotIndex + 1);
                if (selectionStart > dotIndex && decimals.length >= 2) {
                    e.preventDefault();
                }
            }
            return;
        }
        e.preventDefault();
    },

    // Autoformato al perder el foco: convierte 1 → 1.00, 1.2 → 1.20
    formatDecimalOnBlur: (e) => {
        let value = e.target.value;

        // Si está vacío, no hacer nada
        if (!value) return;

        // Si es un número válido
        const parsed = parseFloat(value);
        if (!isNaN(parsed)) {
            // Forzar formato con 2 decimales
            e.target.value = parsed.toFixed(2);
        }
    },

    formatDecimalOnBlur_ReactHook: (e, fieldName, setValue) => {
        let value = e.target.value;

        if (!value) return;

        const parsed = parseFloat(value);

        if (!isNaN(parsed)) {
            setValue(fieldName, parsed.toFixed(2), {
                shouldValidate: true,
                shouldDirty: true,
            });
        } else {
            setValue(fieldName, '', {
                shouldValidate: true,
                shouldDirty: true,
            });
        }
    },

        validateOnlyNumbers: (e) => {
        const { key, ctrlKey, metaKey } = e;
        const allowedControlKeys = [
            'Backspace', 'Delete', 'Tab',
            'ArrowLeft', 'ArrowRight',
            'Home', 'End'
        ];

        // Permitir combinaciones como Ctrl+C, Ctrl+V, Cmd+C, etc.
        if (ctrlKey || metaKey) return;

        // Permitir teclas de control
        if (allowedControlKeys.includes(key)) return;

        // Permitir solo números
        if (!/^[0-9]$/.test(key)) {
            e.preventDefault();
        }
    },

    // Solo letras (sin números ni caracteres especiales)
    validateOnlyLetters: (e) => {
        const { key, ctrlKey, metaKey } = e;
        const allowedControlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', ' '];

        // Permitir combinaciones como Ctrl+C, Ctrl+V
        if (ctrlKey || metaKey) return;

        // Permitir teclas de control y espacio
        if (allowedControlKeys.includes(key)) return;

        // Permitir solo letras (A-Z y a-z)
        if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑ]$/.test(key)) {
            e.preventDefault();
        }
    },

    validateAlphanumeric: (e) => {
        const { key, ctrlKey, metaKey } = e;
        const allowedControlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', ' '];

        // Permitir combinaciones como Ctrl+C, Ctrl+V
        if (ctrlKey || metaKey) return;

        // Permitir teclas de control y espacio
        if (allowedControlKeys.includes(key)) return;

        // Permitir letras, números, tildes y ñ/Ñ
        if (!/^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑ ]$/.test(key)) {
            e.preventDefault();
        }
    },


    // ======================
    // VALIDADORES DE EMAIL
    // ======================

    // Controla caracteres permitidos mientras escribe
    validateEmailKeyDown: (e) => {
        const { key, ctrlKey, metaKey } = e;
        const allowedControlKeys = [
            'Backspace',
            'Delete',
            'Tab',
            'ArrowLeft',
            'ArrowRight',
            'Home',
            'End'
        ];

        if (ctrlKey || metaKey) return;

        if (allowedControlKeys.includes(key)) return;

        if (!/^[a-zA-Z0-9@._-]$/.test(key)) {
            e.preventDefault();
        }
    },

    // Valida formato de email al perder foco
    validateEmailOnBlur: (e) => {
        const value = e.target.value;

        if (!value) return;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (!emailRegex.test(value)) {
            e.target.value = '';
            alert('Correo electrónico no válido');
        }
    },

    // Versión compatible con React Hook Form
    validateEmailOnBlur_ReactHook: (e, fieldName, setValue) => {
        const value = e.target.value;

        if (!value) return;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

        if (emailRegex.test(value)) {
            setValue(fieldName, value.trim(), {
                shouldValidate: true,
                shouldDirty: true,
            });
        } else {
            setValue(fieldName, '', {
                shouldValidate: true,
                shouldDirty: true,
            });
        }
    }
};
